import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { SnackbarProvider } from "notistack";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import { store } from "./app/store";
import router from "router";
import { cyan, red } from '@mui/material/colors';

// import manage messages
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactDOM from "react-dom";


const container = document.getElementById("root")!;
const root = createRoot(container);

const theme = createTheme({
    palette: {
        // mode: "dark",
        background: { default: '#e4f0e2' },
        primary: { main: '#0091ea' },
        // primary: { main: '#880e4f' },
        secondary: { main: '#3d5afe' },
        error: { main: red[800] },
        warning: { main: '#ff9800' },
        info: { main: cyan[700] },
        success: { main: '#43a047' },
    },
});


ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <SnackbarProvider maxSnack={3}>
                        <RouterProvider router={router} />
                    </SnackbarProvider>
                </LocalizationProvider>
            </ThemeProvider>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

ReactDOM.render(
    <ToastContainer />,
    document.getElementById('toast-container')
);
